import { cn } from '@dnx/ui';

/** Ícone do canal da conversa (traço simples, herda a cor do texto). */
export function ChannelIcon({ kind, className }: { kind: 'whatsapp' | 'instagram'; className?: string }) {
  if (kind === 'instagram') {
    return (
      <svg viewBox="0 0 24 24" aria-label="Instagram" role="img" className={cn('size-4', className)} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-label="WhatsApp" role="img" className={cn('size-4', className)} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3.5 20.5 5 16a8.5 8.5 0 1 1 3 3z" /><path d="M9 9.5c0 3 2.5 5.5 5.5 5.5l1-1.5-2-1-1 1a4 4 0 0 1-2-2l1-1-1-2z" />
    </svg>
  );
}
